// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__19WaN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 125
// module chunks = 3